// Vote widget client logic. Reveals comment box after first click,
// posts to /support/feedback/submit, replaces UI with a thank-you state.
import aa from 'search-insights';

// Algolia config rides on the vote widget as data-* (rendered only on support
// article pages) rather than window globals in every page's <head>.
const voteEl = document.querySelector('[data-support-vote]');
const ALGOLIA_APP_ID = voteEl?.dataset.algoliaApp;
const ALGOLIA_SEARCH_KEY = voteEl?.dataset.algoliaKey;
const ALGOLIA_INDEX = voteEl?.dataset.algoliaIndex;

if (ALGOLIA_APP_ID && ALGOLIA_SEARCH_KEY) {
  aa('init', { appId: ALGOLIA_APP_ID, apiKey: ALGOLIA_SEARCH_KEY, useCookie: true });
}

(() => {
  const widgets = document.querySelectorAll('[data-support-vote]');
  if (!widgets.length) return;

  const csrfMeta = document.head.querySelector('meta[name="csrf-token-name"]');
  const csrfTokenMeta = document.head.querySelector('meta[name="csrf-token-value"]');

  widgets.forEach((root) => {
    const articleId = root.dataset.articleId;
    const articleSlug = root.dataset.articleSlug;
    const categorySlug = root.dataset.categorySlug;

    root.addEventListener('click', async (e) => {
      const btn = e.target.closest('[data-vote]');
      if (!btn) return;
      const vote = btn.dataset.vote;

      root.querySelectorAll('[data-vote]').forEach((b) => {
        b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
        b.disabled = true;
      });

      const formData = new FormData();
      formData.append('articleId', articleId);
      formData.append('vote', vote);
      if (csrfMeta && csrfTokenMeta) {
        formData.append(csrfMeta.content, csrfTokenMeta.content);
      }

      let res;
      try {
        const r = await fetch('/support/feedback/submit', {
          method: 'POST',
          headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: formData,
          credentials: 'same-origin',
        });
        res = await r.json();
      } catch (_) {
        res = { ok: false };
      }

      if (!res.ok) {
        root.innerHTML = '<p class="support-vote__prompt">Couldn\'t record that — try again later.</p>';
        return;
      }

      // Stage 2: ask for an optional comment.
      root.innerHTML = `
        <p class="support-vote__prompt">Thanks. Anything to add?</p>
        <textarea class="support-vote__comment" rows="3" maxlength="1000" placeholder="Optional" aria-label="Additional feedback"></textarea>
        <div class="support-vote__actions">
          <button type="button" class="support-vote__btn" data-send>Send</button>
          <button type="button" class="support-vote__skip" data-skip>Skip</button>
        </div>
      `;

      const finalize = (comment) => {
        root.innerHTML = '<p class="support-vote__prompt">Thanks for the feedback.</p>';
        // Hooks for HubSpot + Algolia Insights wired in Tasks 14–15.
        document.dispatchEvent(new CustomEvent('support:vote-finalized', {
          detail: { articleId, articleSlug, categorySlug, vote, comment, shouldTicket: vote === 'no' && comment !== '' },
        }));
      };

      root.querySelector('[data-send]').addEventListener('click', () => {
        finalize(root.querySelector('.support-vote__comment').value.trim());
      });
      root.querySelector('[data-skip]').addEventListener('click', () => finalize(''));
      root.querySelector('.support-vote__comment').focus();
    });
  });
})();

document.addEventListener('support:vote-finalized', (e) => {
  const { articleId, articleSlug, categorySlug, vote, comment, shouldTicket } = e.detail;

  // 1. HubSpot Behavioral Event — only if HubSpot is loaded (consent gated).
  if (window._hsq) {
    window._hsq.push(['trackCustomBehavioralEvent', {
      name: 'dhq_support_article_vote',
      properties: {
        article_slug: articleSlug,
        category_slug: categorySlug,
        vote: vote,
        has_comment: comment !== '',
      },
    }]);
  }

  // 2. Algolia Insights conversion event.
  if (window.aa || aa) {
    const insights = window.aa || aa;
    insights('convertedObjectIDs', {
      eventName: vote === 'yes' ? 'article_voted_helpful' : 'article_voted_unhelpful',
      index: ALGOLIA_INDEX,
      objectIDs: [String(articleId)],
    });
  }

  // 3. Negative + comment → request a Service Hub ticket via the controller.
  if (shouldTicket) {
    const formData = new FormData();
    formData.append('articleId', articleId);
    formData.append('vote', vote);
    formData.append('comment', comment);
    const csrfName = document.head.querySelector('meta[name="csrf-token-name"]')?.content;
    const csrfVal  = document.head.querySelector('meta[name="csrf-token-value"]')?.content;
    if (csrfName) formData.append(csrfName, csrfVal);

    fetch('/support/feedback/ticket', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData,
      credentials: 'same-origin',
    }).catch(() => {/* silent — feedback already saved */});
  }
});
